import React from "react";

export default function OfficerShell(): React.ReactElement {
  return (
    <main style={{ fontFamily: "system-ui", padding: "2rem" }}>
      <h1>Officer Console</h1>
      <p>Patrol UI for guards on shift (P3+).</p>
    </main>
  );
}
